import reducer from "./reducers";

import * as preinscripcionesOps from "./operations";
import * as preinscripcionesTypes from "./types";

export { preinscripcionesOps, preinscripcionesTypes };

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/preinscripciones/index.js